import {ActionTypes} from '../actions';
import createReducer from '../../common/util/createReducer';

const INITIAL_STATE = {
  'loading': false,
  'list': [],
  'filteredList': [],
};

export const transport = (state, action) => {
  return createReducer(INITIAL_STATE, {
    [ActionTypes.FETCHING_TRANSPORTS_LIST]: (state, action) => ({
      ...state,
      'loading': true,
    }),
    [ActionTypes.FETCHED_TRANSPORTS_LIST]: (state, action) => ({
      ...state,
      'loading': false,
      'list': action.response.data,
      'filteredList': action.response.data,
    }),
    [ActionTypes.FETCHED_TRANSPORTS_LIST_FAILED]: (state, action) => ({
      ...state,
      'loading': false,
      'list': [],
      'filteredList': [],
    }),
  })(state, action);
};
